import { WishlistWishlistItem } from "integration/generated/transactions/data-contracts";

export const findDefaultWishlist = (wishlists:WishlistWishlistItem[]) => {
    return wishlists?.find(wl => wl.state === "Default")
}